document.addEventListener("DOMContentLoaded", function () {
	const searchIcon = document.querySelector(".header__icon--search");
	const searchModal = document.querySelector(".search-modal");

	if (searchIcon && searchModal) {
		searchIcon.addEventListener("click", function (e) {
			e.preventDefault();
			// Toggle active class on modal
			searchModal.classList.toggle("active");

			// Optionally toggle a class on the icon itself
			searchIcon.classList.toggle("is-active");
		});
	}

	document.addEventListener("click", function (e) {
		const searchIcon = document.querySelector(".header__icon--search");
		const searchModal = document.querySelector(".search-modal");

		if ( !searchModal.contains(e.target) && !searchIcon.contains(e.target) ) {
			searchModal.classList.remove("active");
			searchIcon.classList.remove("is-active");
		}
	});
});